import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getUserPanelRole } from 'selectors';
import { analyticsSummaryActions } from 'pages/insights/containers/analyticsSummaryContainer/actions';
import BillingNotifications from 'pages/notifications/containers/notifications/components/billing';
import { getCoursesCompletionInfo, getCoursesEnrollmentInfo, getUserSites } from 'selectors';
import NpsDialog from 'pages/dashboard/containers/npsDialog';
import { quickStatsActions } from 'pages/dashboard/containers/quickStats/actions/quickStats';
import UserGuide from 'pages/dashboard/containers/displayDemo';
import Polling from 'pages/dashboard/containers/Polling';
import FeatureOverview from 'pages/dashboard/containers/featureOverview';
import DashboardContainer from 'pages/dashboard/containers/DashboardContainer';

const moment = require('moment');

const Dashboard = (props) => {
  const { useSites, dispatch } = props;

  useEffect(() => {
    const defaultState = {
      filter_type: 'this_year',
      filter_start_date: moment().subtract(1, 'months'),
      filter_end_date: moment()
    };
    dispatch(quickStatsActions.fetchMAUSQuickStats({ useSites: useSites }));
    dispatch(
      analyticsSummaryActions.fetchGeneralSitesMetrics({
        filter_type: 'this_month',
        filter_start_date: defaultState.filter_start_date,
        filter_end_date: defaultState.filter_end_date,
        useSites: useSites
      })
    );
    dispatch(
      analyticsSummaryActions.fetchCoursesEnrollmentStats({
        filter_type: defaultState.filter_type,
        filter_start_date: defaultState.filter_start_date,
        filter_end_date: defaultState.filter_end_date,
        useSites: useSites
      })
    );
    dispatch(
      analyticsSummaryActions.fetchCoursesCompletionStats({
        filter_type: defaultState.filter_type,
        filter_start_date: defaultState.filter_start_date,
        filter_end_date: defaultState.filter_end_date,
        useSites: useSites
      })
    );
  }, [useSites, dispatch]);

  return (
    <div>
      <Polling />
      <UserGuide />
      <FeatureOverview />
      <NpsDialog />
      <BillingNotifications />
      <DashboardContainer />
    </div>
  );
};

function mapStateToProps(state) {
  const panel_role = getUserPanelRole(state);
  const completion_results = getCoursesCompletionInfo(state);
  const enrollment_results = getCoursesEnrollmentInfo(state);
  const useSites = getUserSites(state);
  return {
    useSites,
    completion_results,
    enrollment_results,
    panel_role,
    userSelectedSite: state.USER_SITES.selected_sites
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(quickStatsActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
